module.exports = "/following@2x-e587361f8c38a5d3098fbe443e80d5c0.png";